const defaultConfig = {
  classWrapper: '.header__wrapper',
  classFixed: 'header--fixed',
  classAnimate: 'animate',
  initialScroll: 0,
};

export default class HeaderStatic {
  constructor(element, config) {
    this.element = element;
    this.config = { ...defaultConfig, ...config };

    this.setWrapperHeight();
    this.init();

    return this;
  }

  setWrapperHeight() {
    if (this.element.closest) {
      const height = this.element.clientHeight;
      const wrapper = this.element.closest(this.config.classWrapper);
      wrapper.style.height = height;
    }
  }

  // eslint-disable-next-line
  handleScroll(scrollPos) {}

  init() {
    let lastKnownScrollPos = window.scrollY;
    let ticking = false;

    this.handleScroll(lastKnownScrollPos);

    window.addEventListener('scroll', () => {
      lastKnownScrollPos = window.scrollY;

      if (!ticking) {
        window.requestAnimationFrame(() => {
          this.handleScroll(lastKnownScrollPos);
          ticking = false;
        });

        ticking = true;
      }
    });
  }

  //   update() {}

  destroy() {
    this.config.body.removeEventListener('scroll');
  }
}



// WEBPACK FOOTER //
// ./src/components/Header/Header.static.js